import React from "react";
import "./brands.css";
import BrandsOfSnaitheImage from "../../../assets/BrandsOfSnaithe.jpg";

const BrandsOfSnaithe = () => {
  return (
    <div className="Brands-Of-Snaithe-custom">
      <img
        src={BrandsOfSnaitheImage}
        alt="Brands of Snaithe"
        className="Brands-Of-Snaithe-custom-image"
      />
    </div>
  );
};

export default BrandsOfSnaithe;
